const rawApiBase = import.meta.env.VITE_API_BASE || "https://dev.dlm.pl:4000";

export const API_BASE = rawApiBase.replace(/\/$/, "");
export const API_PRIVATE_BASE = API_BASE.endsWith("/api")
  ? API_BASE
  : `${API_BASE}/api`;
export const API_AUTH_BASE = `${API_PRIVATE_BASE}/auth`;
